import React, { FC } from 'react'
import { generatePath, Link, useLocation } from 'react-router-dom'
import { format, utcToZonedTime } from 'date-fns-tz'
import { useSelector } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { iconPerson } from '../../assets/images/images'
import { IClientEvent } from '../../interfaces/IClientDetails'
import {
  EVENTS_DATETIME_FORMAT,
  REPORT_DATETIME_FORMAT,
} from '../../enums/common'
import { joinData } from '../../utils/helpers'
import { statusNetworkSelector } from '../../store/selectors'
import { DCR_CALL } from '../../constants/userData'
import DynamicFormattedMessage from '../common/ui/DynamicFormattedMessage'

export const ClientEventCard: FC<IClientEvent> = ({
  data,
  path,
  clientId,
  customClass,
  disabled = false,
}) => {
  const {
    resourceType,
    id,
    startDate,
    eventType,
    formationType,
    outcome,
    contactPerson,
    comment,
  } = data
  const hasTime = startDate.includes('T')
  const eventDate = utcToZonedTime(new Date(startDate), 'UTC')
  const isDcrCall = resourceType === DCR_CALL
  const formattedDate =
    isDcrCall || !hasTime
      ? format(eventDate, REPORT_DATETIME_FORMAT)
      : format(eventDate, EVENTS_DATETIME_FORMAT)
  const contactName = contactPerson !== ' ' ? contactPerson : '-'
  const { hasNetwork } = useSelector(
    statusNetworkSelector.getStatusNetworkValue
  )
  const { pathname } = useLocation()

  return (
    <div className={`clientEventCard ${customClass && customClass}`}>
      <p className="clientEventCardDate">{formattedDate}</p>
      <div className="mb15 pt1 dFlex">
        <Link
          to={{
            pathname: generatePath(path, {
              appointmentId: id,
              reportId: id,
              clientId,
            }),
            state: { clientId, eventBackUrl: pathname },
          }}
          className={`linkUnstyled clientEventCardType ${
            !hasNetwork && disabled ? 'notAllowed textLighterGrey' : ''
          }`}
          onClick={(e) =>
            !hasNetwork && disabled ? e.preventDefault() : () => {}
          }
        >
          {isDcrCall && <DynamicFormattedMessage id="clientFile.dcrCall" />}
          {joinData([eventType, formationType, outcome])}
        </Link>
      </div>
      <div className="dFlex clientEventCardClientName">
        <div className="clientEventCardIcon" data-tip={contactName}>
          <img src={iconPerson} alt="user person icon" className="mr1" />
          <ReactTooltip effect="solid" place="left" />
        </div>
        {comment ? (
          <span dangerouslySetInnerHTML={{ __html: comment }} />
        ) : null}
      </div>
    </div>
  )
}
